import { FluentButton } from 'owa-fluent-v9-shims';
import { toggleLeftPaneAriaLabel } from './HamburgerButton.locstring.json';
import { observer } from 'mobx-react-lite';
import { IButton } from '@fluentui/react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import * as React from 'react';
import type { LightningId } from 'owa-lightning-v2';
import { isFeatureEnabled } from 'owa-feature-flags';
import styles from './HamburgerButton.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export interface HamburgerButtonProps extends React.HTMLAttributes<HTMLDivElement> {
    isPaneExpanded: boolean;
    toggleHamburgerButton: () => void;
    onFreDismiss?: () => void;
    freButtonCustomClass?: string;
    lid?: LightningId;
}

export interface HamburgerHandle {
    focus(): void;
    openMenu(): void;
    dismissMenu(): void;
    getRef(): HTMLDivElement;
}

export const HamburgerButton = observer(
    function HamburgerButton(props: HamburgerButtonProps, ref: React.Ref<HamburgerHandle>) {
        // Button ref is being forwarded as a workaround for an A11Y issue in Calendar module
        // The correct fix (which will allow the ref forwarded to be removed) is being tracked on VSO #51744
        const buttonRef = React.useRef<IButton>(null);
        const divRef = React.useRef<HTMLDivElement>();

        React.useImperativeHandle(ref, () => ({
            focus: () => {
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2531 (48,17): Object is possibly 'null'.
                // @ts-expect-error
                buttonRef.current.focus();
            },
            openMenu: () => {
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2531 (54,17): Object is possibly 'null'.
                // @ts-expect-error
                buttonRef.current.openMenu();
            },
            dismissMenu: () => {
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2531 (60,17): Object is possibly 'null'.
                // @ts-expect-error
                buttonRef.current.dismissMenu();
            },
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (65,13): Type '() => HTMLDivElement | undefined' is not assignable to type '() => HTMLDivElement'.
            // @ts-expect-error
            getRef: () => {
                return divRef.current;
            },
        }));

        return (
            <div
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2322 (81,17): Type 'MutableRefObject<HTMLDivElement | undefined>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
                // @ts-expect-error
                ref={divRef}
                className={classNames(
                    styles.hamburgerButtonWrapper,
                    isFeatureEnabled('mon-densities') && styles.hamburgerButtonWrapperNext
                )}>
                {renderIconButton(props, buttonRef)}
            </div>
        );
    },
    { forwardRef: true }
);

function renderIconButton(props: HamburgerButtonProps, buttonRef: React.Ref<IButton>) {
    const { isPaneExpanded, toggleHamburgerButton } = props;
    const fontSize = isFeatureEnabled('mon-densities') ? '14px' : 'auto';
    return (
        <FluentButton
            appearance="icon"
            key={'button'}
            checked={isPaneExpanded}
            className={styles.hamburgerButton}
            iconProps={{
                iconName: ControlIcons.GlobalNavButton,
                styles: { root: { fontSize: fontSize } },
            }}
            onClick={toggleHamburgerButton}
            title={loc(toggleLeftPaneAriaLabel)}
            aria-label={loc(toggleLeftPaneAriaLabel)}
            aria-expanded={isPaneExpanded}
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2769 (128,13): No overload matches this call.
            // @ts-expect-error
            componentRef={buttonRef}
        />
    );
}
